import type { ModalState } from '@/atoms'

import { ModalContent } from '@/components/Modal'

import { useConfigureController, useController } from '../hooks/useController'
import { Body } from './Body'
import { DiscardConfirmDialog } from './DiscardConfirmDialog'
import { Footer } from './Footer'
import { Header } from './Header'

const modalConfig: Partial<ModalState['config']> = {
  disableBackdropClick: true,
  disableEscapeKeyDown: true,
}

export function Content() {
  const { ready } = useConfigureController()

  if (!ready) return null

  return (
    <>
      <InnerContent />
      <DiscardConfirmDialog />
    </>
  )
}

function InnerContent() {
  const {
    data: { progress },
  } = useController()

  const isComplete = progress === 'completed'

  return (
    <ModalContent
      config={modalConfig}
      header={<Header showClose={isComplete} />}
      footer={isComplete ? undefined : <Footer />}
      minWidth={isComplete ? 536 : 793}
      maxWidth={isComplete ? 536 : 793}
      data-testid="buildModal"
      data-trackid="buildModal"
    >
      <Body />
    </ModalContent>
  )
}
